const zero = (n) => {
  return n < 10 ? '0'+ n : n;
}
export const getDate = () => {
  let d = new Date();
  let y = d.getFullYear();
  let m = d.getMonth() + 1;
  let day = d.getDate();
  return `${y}年${zero(m)}月${zero(day)}日`
}


export const packDate = (date) => {
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let day = date.getDate();
  return `${y}-${zero(m)}-${zero(day)}`
}